import dayjs from 'dayjs';
import Kpi from './Kpi.js';
import KpiWeight from './KpiWeight';

export default class Achievement {
  constructor(data) {
    this.id = data?.id;
    this.evaluationTermId = data?.evaluationTermId;
    this.userId = data?.userId;
    this.jobId = data?.jobId;
    this.kpiId = data?.kpiId;
    this.value = data?.value ? Number(data.value) : null;
    this.createdAt = data?.createdAt ? dayjs(data.createdAt) : null;
    this.updatedAt = data?.updatedAt ? dayjs(data.updatedAt) : null;

    this.kpi = data?.kpi ? new Kpi(data.kpi) : null;
    this.kpiWeight = data?.kpiWeight ? new KpiWeight(data.kpiWeight) : null;
  }
}
